import React, { useState, useEffect, useRef, useCallback } from "react";
import "./lottery-bet.css";
import { Logout } from "../../utils/logout";
import { DoorOpen, DoorOpenFill } from "react-bootstrap-icons";
import Barcode from "react-jsbarcode";
import { socket } from "../../io";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { addSeconds } from "date-fns";
import { headers, url } from "../../utils/const";
import imgLogo from "../../assets/logo-reina.png";
import SorteoLive from "./sorteo-live";
let bettingShow = [];
let print = undefined;
const createIdempotencyKey = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return "reina-" + Date.now() + "-" + Math.random().toString(36).slice(2);
};
function LoteryBet() {
  let newTicket = [];
  let contentPrint = "print";
  const [time, setTime] = useState("");
  const [hour, setHour] = useState("");
  const [nextRun, setNextRun] = useState("");
  const [run, setRun] = useState("");
  const [betted, setBetted] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [firstEnter, setFirstEnter] = useState(false);
  const [textareaValue, setTextareaValue] = useState("");
  const [numberInputValue, setNumberInputValue] = useState("");
  const [currentBet, setCurrentBet] = useState([]);
  const [error, setError] = useState("");
  const [PrintSt, setPrintSt] = useState();
  const [active, setActive] = useState(false);
  const [show, setShow] = useState("");
  const [inTeclado, setInTeclado] = useState("");
  const [winner, setWinner] = useState("");
  const [newTicketList, setNewTicketList] = useState([]);
  const [showTicket, setShowTicket] = useState(false);
  const [showTextArea, setShowTextArea] = useState(false);
  const textareaRef = useRef(null);
  const ticketNumberRef = useRef(null);
  const inputValueRef = useRef(null);
  const salePendingRef = useRef(false);
  const actionPendingRef = useRef(false);
  const paymentConfirmationRef = useRef(null);
  /** Datos de la Carrera actual para cual sera la apuesta  IMP*/
  useEffect(() => {
    if (!localStorage.getItem("user")) return (window.location.href = "/");
    socket.on("scream", (data) => {
      setTime((value) => {
        if (value && value <= 10) {
          setActive(false);
        }
        return data.time;
      });

      const hr = `${new Date().getHours().toString().padStart(2, "0")}:${new Date().getMinutes().toString().padStart(2, "0")}:${new Date().getSeconds().toString().padStart(2, "0")}`;
      const lasthours = addSeconds(new Date(), data.time);
      setHour(() => hr);
      setNextRun(() => `${lasthours.getHours().toString().padStart(2, "0")}:${lasthours.getMinutes().toString().padStart(2, "0")}:${lasthours.getSeconds().toString().padStart(2, "0")}`);
    });
    if (PrintSt && PrintSt.num) {
      if (localStorage.getItem("level") !== "4") return (window.location.href = "/");
      window.print();
      setPrintSt(undefined);
      print = undefined;
    }
    /**Socket.Io */
    socket.on("run", (data) => setRun(data.run));
    /**Lectura codigo de barra */
    // Agregar el evento al documento cuando el componente se monta
    const handleKeyDown = (event) => {
      if (event.key !== "Enter") {
        const nume = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        // if (nume.includes(Number(event.key))) InputTeclado(event.key);
      } else {
        // if (event.key === "Enter") setShowTicket(true);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    // Eliminar el evento al documento cuando el componente se desmonta
    return () => {
      // socket.off("screen", handleScreen);
      socket.off("run", setRun);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [PrintSt]);
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [textareaValue]);
  const Mix = useCallback((type)=>{
    if(type=='pale'){
      const qArray = currentBet.filter(item=>item.type=='Q').map(item=> item.bet[0]);
      const newPale = []
  
      for (let i = 0; i < qArray.length; i++) {
          for (let j = i + 1; j < qArray.length; j++) {
              newPale.push([qArray[i], qArray[j]]);
          }
      }
     const newOption = newPale.map(q=> {return{
        amount:10,
        bet:q,
        type:'P'
      }})
      newOption.forEach(opt=>{
        setCurrentBet(bet=>[...bet,opt])
        setTextareaValue(pre=> `${pre}\n$${opt.amount} P ${opt.bet}`)
      })
      
  console.log(textareaValue)
    }
    if(type=='trip'){
  
    }
  },[currentBet, textareaValue])
  const handleInputChange = (e) => {
    const { value } = e.target;
    const lastChar = value.slice(-1);
    if (/^\d*$/.test(lastChar) || (firstEnter && lastChar === "$")) {
      if (paymentConfirmationRef.current?.ticket !== value.replace("$", ""))
        paymentConfirmationRef.current = null;
      setInputValue(value);
    }
  };
  if (!localStorage.getItem("user")) {
    return (window.location.href = "/");
  }
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue == "") {
      if (salePendingRef.current) return;
      salePendingRef.current = true;
      fetch(`${url}/lotery-bet`, {
        method: "POST",
        headers: { ...headers, "x-idempotency-key": createIdempotencyKey() },
        body: JSON.stringify([currentBet]),
      })
        .then(async (res) => {
          const data = await res.json();
          if (!res.ok) {
            const message = typeof data === "string" ? data : data?.message;
            throw new Error(message || "No se pudo registrar la jugada");
          }
          if (localStorage.getItem("level") === "4" && (!data || !Array.isArray(data.betted))) {
            throw new Error("El servidor no devolvió los datos del ticket.");
          }
          return data;
        })
        .then((data) => {
          ToPrint(data);
          if (Array.isArray(data?.betted)) setCurrentBet([]);
        })
        .catch((cause) => {
          const message = typeof cause?.message === "string" ? cause.message : "No se pudo registrar la jugada";
          setWinner(message);
          setError(message);
        })
        .finally(() => {
          salePendingRef.current = false;
        });
    }
    if (e.key === "Enter") {
      if (firstEnter === false) {
        setInputValue((prev) => `${prev}$`);
        setFirstEnter(true);
      } else {
        if (firstEnter === true) {
          const [firstPart, secondPart] = inputValue.split("$");
          if (firstPart.length === 2 || firstPart.length === 4 || firstPart.length === 6) {
            const spacedFirstPart = [
              ...new Set(
                firstPart
                  .match(/.{1,2}/g)
                  .join(" ")
                  .split(" ")
              ),
            ].join(" ");
            const newText = `$${secondPart} ${spacedFirstPart.length == 8 ? "T " : spacedFirstPart.length == 5 ? "P " : "Q "}${spacedFirstPart}`;
            setTextareaValue((prev) => `${prev}\n${newText}`);
            setCurrentBet((bet) => [...bet, { amount: parseFloat(secondPart), type: spacedFirstPart.length == 8 ? "T " : spacedFirstPart.length == 5 ? "P " : "Q ", bet: spacedFirstPart }]);
            setInputValue("");
            setFirstEnter(false);
          } else {
            setError("La longitud del número debe ser 2, 4 o 6.");
          }
        }
      }
    }
  };
  /**IMP */
  /**Eliminar */
  const Eliminar = () => {
    if (ticketNumberRef.current.value !== "") {
      setShow(true);
    } else {
      setInputValue("");
      setFirstEnter(false);
      setNewTicketList([]);
      newTicket = [];
      bettingShow = [];
      setTextareaValue("");
      setCurrentBet([]);
    }
  };

  /**Eliminar Ticket */
  const EliminarTicket = () => {
    if (actionPendingRef.current) return;
    actionPendingRef.current = true;
    setShowTextArea(true);
    fetch(`${url}/lotery-bet/pay`, {
      method: "post",
      headers: headers,
      body: JSON.stringify({ ticket: inputValue.replace("$", ""), action: "Delete" }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (typeof data != "string" && !data.msg) {
          setWinner("");
          setWinner(() => data.amountToPay);
        } else if (typeof data == "string") {
          setWinner("");
          setWinner(() => data);
        } else if (data.msg && data.msg.includes("agado")) {
          print = data.ticket;
          setWinner(data.msg);
        }
        if (showTicket === true) {
          setTimeout(() => setShowTicket(false), 150);
          Clear();
        }
        paymentConfirmationRef.current = null;
        setShow(false);
      })
      .catch(() => setWinner("No se pudo anular el ticket"))
      .finally(() => {
        actionPendingRef.current = false;
      });
  };
  /**Realizar apuesta */
  const ToPrint = (data) => {
    console.log(data);
    if (localStorage.getItem("level") !== "4") return (window.location.href = "/");
    //  if (active === true) {
    setActive(false);

    if (typeof data === "string" || !Array.isArray(data?.betted)) {
      const message = typeof data === "string"
        ? data
        : typeof data?.message === "string"
          ? data.message
          : "Respuesta inválida del servidor al generar el ticket.";
      setWinner(message);
      return;
    }
    setWinner("");
    setNewTicketList([]);
    contentPrint = "";
    print = data;
    setPrintSt(data);
    setInputValue("");
    setTextareaValue("");
    setFirstEnter(false);

    // }
  };
  /**Limpia el input del ticket */
  const Clear = () => {
    setInTeclado("");
  };
  /**Enter Para Pago */
  const EnterPay = (action) => {
    if (actionPendingRef.current) return;
    actionPendingRef.current = true;
    const ticket = inputValue.replace("$", "");
    const confirmation = paymentConfirmationRef.current?.ticket === ticket
      ? paymentConfirmationRef.current.token
      : undefined;
    const requestHeaders = action === "repeat"
      ? { ...headers, "x-idempotency-key": createIdempotencyKey() }
      : headers;
    setShowTextArea(true);
    setShowTicket(false);
    fetch(`${url}/lotery-bet/pay`, {
      method: "post",
      headers: requestHeaders,
      body: JSON.stringify({
        ticket,
        action,
        ...(action === "pay" && confirmation
          ? { confirmationToken: confirmation }
          : {}),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (typeof data != "string" && !data.msg) {
          if (data.confirmationToken) {
            paymentConfirmationRef.current = {
              ticket,
              token: data.confirmationToken,
            };
          }
          setWinner("");
          setWinner(() => parseInt(data.amountToPay));
        } else if (typeof data == "string") {
          paymentConfirmationRef.current = null;
          setWinner("");
          setWinner(() => data);
          Clear();
          setInputValue("");
          setFirstEnter(false);
        } else if (data.msg && data.msg.includes("agado")) {
          paymentConfirmationRef.current = null;
          print = data.ticket;
          setPrintSt(() => data.ticket);
          setWinner(data.msg);

          Clear();
          setInputValue("");
          setFirstEnter(false);
        } else {
          if (data.hasOwnProperty("msg") && data.msg.includes("petid")) {
            paymentConfirmationRef.current = null;
            setWinner(data.msg);
            print = data.ticket;
            setPrintSt(() => data.ticket);
            setInTeclado("");
            setTextareaValue("");
            setInputValue("");
            setFirstEnter(false);
          }
        }
      })
      .catch(() => setWinner("No se pudo completar la operación"))
      .finally(() => {
        actionPendingRef.current = false;
      });
  };
  const handleTextareaChange = (e) => {
    setTextareaValue(e.target.value);
  };

  const handleNumberInputChange = () => {
    setInTeclado(ticketNumberRef.current.value);
  };

  if (time && time > 10) {
    return (
      <div className="container-fluid vh-100 vw-100">
        <div className="yPrint print text-center">
          <div className="p-0 m-0">
            {print && print.winner ? (
              ""
            ) : print && print.codeRun ? (
              <div className="p-0 m-0">
                <div className="col-12 justify-content-center p-0 m-0">
                  <div className="col-12">
                    <Barcode
                      value={print ? print.num : "000000"}
                      options={{
                        format: "code128",
                        height: 25,
                        displayValue: false,
                      }}
                      renderer="svg"
                    />
                  </div>
                </div>
                <h6>{print ? print.pv : ""}</h6>
                <div className="col-12 row justify-content-center p-0 m-0">
                  <div className="col fs-6 p-0 m-0">Sorteo: {print ? `${print.codeRun}` : ""}</div>
                  <div className="col fs-6 p-0 m-0">Ticket No.: {print ? print.num : ""}</div>
                </div>
                <h6>Fecha: {print ? `${new Date(print.date).toLocaleDateString("es-ES")} ${new Date(print.date).getHours().toString().padStart(2, "0")}:${new Date(print.date).getMinutes().toString().padStart(2, "0")}:${new Date(print.date).getSeconds().toString().padStart(2, "0")}` : ""}</h6>
              </div>
            ) : (
              <div className="p-0 m-0">
                <div className="col-12 justify-content-center p-0 m-0">
                  <div className="col-12">
                    <Barcode
                      value={print ? print.num : "000000"}
                      options={{
                        format: "code128",
                        height: 25,
                        displayValue: false,
                      }}
                      renderer="svg"
                    />
                  </div>
                </div>
                <h6>{new Date().getHours()}</h6>
                <div className="col-12 row justify-content-center p-0 m-0">
                  <div className="col fs-6 p-0 m-0">Sorteo: {print ? `${print.codeRun}` : ""}</div>
                  <div className="col fs-6 p-0 m-0">Ticket No.: {print ? print.num : ""}</div>
                </div>
                <h6>Fecha: {new Date().toLocaleDateString("es-ES")}</h6>
              </div>
            )}
            {print && print.winner ? (
              <div className="text-center">
                <h3>Monto Ganador:</h3>
                <div className=" col-12 divLogoPrint align-midle mt-0 pt-0">
                  <img className="imgLogoPrint" src={imgLogo} />
                </div>
                <h3>{parseInt(print.winner.amountToPay).toLocaleString("en-EN", { maximumFractionDigits: 0 })}</h3>
                <div>.</div>
              </div>
            ) : (
              <div>
                <div className=" col-12 divLogoPrint align-midle">
                  <img className="imgLogoPrint " src={imgLogo} />
                </div>
                <table className="table table-sm col-12 p-0 m-0 lh-1">
                  <thead>
                    <tr>
                      <th className="ml-3 pl-3 text-start fs-5">Jugadas</th>
                      <th className="ml-3 pl-3 fs-5">Apostado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {print
                      ? print.betted.map((z) => (
                          <tr key={z.code} className="">
                            <td className="ml-3 pl-3 text-start fs-5">{z.numbers?.length == 1 ? `Q ${z.numbers[0]}` : z.numbers?.length == 2 ? `P ${z.numbers.join(" ")}` : z.numbers?.length == 3 ? `T ${z.numbers.join(" ")}` : "No Valida"}</td>
                            <td className="fs-5">
                              {parseInt(z.betted).toLocaleString("en-EN", {
                                maximumFractionDigits: 1,
                              })}
                            </td>
                          </tr>
                        ))
                      : ""}
                  </tbody>
                </table>
                <h2>Total Apostado: {print ? print.amount : ""}</h2>
                <div>.</div>
              </div>
            )}
          </div>
        </div>

        <div className="noPrint">
          <Modal show={show} onHide={!show} size="sm" className="" centered>
            <Modal.Header closeButton></Modal.Header>
            <form>
              <Modal.Body>
                <h3>Desea Anular Tickey {inTeclado}?</h3>
              </Modal.Body>
              <Modal.Footer className="col-12 row justify-content-between">
                <div className="col">
                  {" "}
                  <button type="button" className="btn btn-warning form-control" onClick={() => setShow(false)}>
                    Cerrar
                  </button>
                </div>
                <div className="col">
                  {" "}
                  <button type="button" onClick={EliminarTicket} className="btn btn-danger form-control">
                    {" "}
                    Aceptar{" "}
                  </button>
                </div>
              </Modal.Footer>
            </form>
          </Modal>
          <Modal show={showTicket} onHide={!showTicket} size="" className="noPrint" centered>
            <Modal.Header>
              <button className="btn btn-close" onClick={() => setShowTicket(false)}></button>
            </Modal.Header>
            <form>
              <Modal.Body className="col-12 text-center fs-1">Ticket: {inTeclado}</Modal.Body>
              <Modal.Footer>
                <div className="col-12 row">
                  <div className="col">
                    <input className="btn btn-primary form-control fs-3" type="button" onClick={() => EnterPay("pay")} value={"Pagar"} />
                  </div>

                  <div className="col">
                    <input type="button" className="form-control btn btn-danger fs-3" onClick={Eliminar} value="Eliminar" />
                  </div>
                  <div className="col">
                    <button type="button" className="form-control btn btn-warning fs-3" onClick={() => EnterPay("repeat")}>
                      Repetir
                    </button>
                  </div>
                </div>
              </Modal.Footer>
            </form>
          </Modal>
        </div>
        <div className="container-fluid row p-3 justify-content-start noPrint">
          <div className="">
            <header>
              <nav>
                <div className="">
                  <Link className="vol venta" to="/bet">
                    VENTA
                  </Link>
                  <Link to="/line" className="vol lin">
                    LINEA
                  </Link>
                  <Link className="vol res" to="/history">
                    RESULTADOS
                  </Link>
                  <Link className="vol volvent" to="/venta">
                    VOLUMEN DE VENTAS
                  </Link>
                  <Link className="vol volvent" to="/player">
                    JUGADORES
                  </Link>
                  <button className="boton_menu bg-danger" onClick={Logout}>
                    <DoorOpenFill />
                  </button>
                </div>
              </nav>
            </header>
            <div className="row col-12">
              <h1 className="">LA REiNA</h1>
            </div>
          </div>
          <div className="col-12 p-0 m-0 row justify-content-end form-group ">
            <div className="col-12 p-0 m-0 row p-3 justify-content-start">
              <div className="row col-12 justify-content-between">
                <div className="col"></div>
                <div className="col"></div>
                <div className="col fs-2 text-end text-white">Proximo Sorteo en: {time} Seg.</div>
              </div>
              <div className="col-4 p-0 m-0 form-group"> </div>
            </div>

            <div className="col-12 row justify-content-center ">
              <div className="col-6 p-0 m-0">
                <div className="text-center text-white fs-2 bg-dark">{winner}</div>
                <input type="text" className="form-control" value={inputValue} onChange={handleInputChange} onKeyDown={handleKeyDown} style={{ marginRight: "10px" }} />
                <div className="col-12 row mt-3 pt-3">
                  <div className="col">
                    <input className="btn btn-primary form-control fs-2" type="button" onClick={() => EnterPay("pay")} value={"Pagar"} />
                  </div>

                  <div className="col">
                    <input type="button" className="form-control btn btn-danger fs-2" onClick={Eliminar} value="Eliminar" />
                  </div>
                  <div className="col">
                    <button type="button" className="form-control btn btn-success border-white fs-2" onClick={() => EnterPay("repeat")}>
                      Repetir
                    </button>
                  </div>
                </div>
              </div>
            <div className="col-12"></div>
              <div className="col-6 p-0 m-0 pt-3 mt-3">
                <textarea className="form-control p-0 m-0 pt-3 mt-1 fs-3 text-center" ref={textareaRef} value={textareaValue} onChange={handleTextareaChange} style={{ width: "100%", resize: "none" }} />
              </div>
              <div className="col-12"></div>
              <div className="col-6 justify-content-end">
                <span className="text-white fs-3 text-end">Monto Apostado: </span><span className="fs-1 text-warning">${currentBet.map((item) => item.amount).reduce((acum, current) => acum + current, 0)}</span>
              </div>
              <div className="col-12"></div>
             {/* <div className="col-6 pr-3 mr-3 row">
                <button className="form-control btn btn-danger fs-2" style={{ marginTop: "10px" }} onClick={()=>Mix('pale')}>
                  COMBINAR PALE
                </button>
              </div>*/}
              <div className="col-6 pr-3 mr-3 row">
                <button className="form-control btn btn-danger fs-2" style={{ marginTop: "10px" }} onClick={Eliminar}>
                  CANCELAR
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <SorteoLive />
    );
  }
}
export default LoteryBet;
